import * as React from 'react';


const AssignButton = ({ selectedOptionKey, assignAction, }) => {
  if (!selectedOptionKey) { return <span /> }

  return (
    <div className="assign-button-container">
      <button className="quill-button green focus-on-light large contained" onClick={() => assignAction(selectedOptionKey)}>
        {selectedOptionKey}
      </button>
    </div>
  )
}

export default AssignButton
